module.exports = __webpack_public_path__ + "static/img/3.9d2262e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-en/3.jpg
// module id = YE9H
// module chunks = 1